<template>
  <div class="attachments">
    <span class="label" :style="labelStyle">{{ labelText }}:</span>
    <div class="attachmentsContent">
      <el-upload class="upload-demo" ref="upload" :action="attachmentsUploadUrl" :on-remove="handleRemoveAttachment"
        :on-success="handleSuccessAttachment" :file-list="attachmentList" :before-upload="beforeUpload"
        :auto-upload="true" :limit=1 :data='{type: typeNum}' :accept="accept">
        <el-button slot="trigger" size="small" type="primary">选取文件</el-button>
        <!--<div slot="tip" class="el-upload__tip">只能上传pdf/jpg文件，且不超过500MB</div>-->
      </el-upload>
    </div>
  </div>
</template>

<script>
// import CryptoJS from 'crypto-js'
export default {
  name: 'fileUpload',
  props: {
    label: String,
    value: Array,
    labelWidth: String,
    type: Number,
    accept: String
  },
  data() {
    return {
      attachmentsUploadUrl: pubServer + '/upload/v2/upload',
      // attachmentsUploadUrl: 'https://uat-nikegetit2.nike.com/public-service-new/upload/upload',
      attachmentList: this.value,
      labelText: this.label || '文件上传',
      typeNum: this.type || 6,
      hash: ''
    }
  },
  methods: {
    handleRemoveAttachment(file, fileList) {
      let attachmentListTemp = []
      this.attachmentList.forEach((item) => {
        // eslint-disable-next-line eqeqeq
        if (item.uid != file.uid) {
          attachmentListTemp.push(item)
        }
      })
      this.attachmentList = attachmentListTemp
      this.$emit('input', this.attachmentList)
    },
    async handleSuccessAttachment(response, file, fileList) {
      if (response.code === 200) {
        let res = response.data
        let urls = { name: res.result.filename, docUrl: res.result.imageUrl }
        this.attachmentList.push(urls)
        this.$emit('input', this.attachmentList)
      } else {
        this.$message.error(response.message)
      }
    },
    async beforeUpload(file) {
      const isSupport = file.type === 'application/pdf'
        || file.name.endsWith("xls")
        || file.name.endsWith("xlsx")
        || file.name.endsWith("doc")
        || file.name.endsWith("docx")
        || file.name.endsWith("ppt")
        || file.name.endsWith("pptx")
      if (!isSupport) {
        this.$message.error('附件上传仅支持PDF、Word、PPT、Excel!');
        throw new Error('图片上传仅支持 JPG 或 PNG 格式!');
      }
      
      // this.hash = await this.getFileHash(file)

      return isSupport;
    },
    // async getFileHash(file) {
    //   return new Promise(function (resolve, reject) {
    //     let reader = new FileReader();
    //     reader.readAsArrayBuffer(file);
    //     reader.onload = function (evt) {
    //       let fileStr = evt.target.result;
    //       let wordArray = CryptoJS.lib.WordArray.create(fileStr);
    //       let fileHash = CryptoJS.SHA256(wordArray).toString().toLowerCase();
    //       resolve(fileHash);
    //     }
    //   })
    // },
  },
  watch: {
    value: function (val, oldVal) {
      this.attachmentList = val
    }
  },
  computed: {
    labelStyle() {
      const w = this.labelWidth || '100'
      return {
        width: w + 'px'
      }
    }
  }
}
</script>

<style lang="sass" scoped>
  .attachments
    display: flex
    margin-bottom: 20px
    .label
      text-align: right
      vertical-align: middle
      float: left
      font-size: 14px
      color: #606266
      line-height: 36px
      padding: 0 12px 0 0
      -webkit-box-sizing: border-box
      box-sizing: border-box
      flex-shrink: 0
    .input-box
      font-size: 12px
      color: #606266
      span
        margin-left: 5px
    .attachmentsContent
      line-height: 36px
      width: 100%
</style>



// WEBPACK FOOTER //
// src/openSurvey/components/fileUpload.vue